'use client';
import { log } from '@/utils/logger';
import request from '@/utils/queryData/rest/clientRequest';

const processNewSearchResults = ({ currentSearchResults, fetchedData }) => {
  const newSearchResults = fetchedData || [];

  const mergedSearchResults = [...currentSearchResults, ...newSearchResults];

  // deduplicate
  const deduplicatedSearchResults = mergedSearchResults.filter(
    (result, index, self) =>
      index === self.findIndex(t => t.document.derivedStructData.title === result.document.derivedStructData.title)
  );

  return deduplicatedSearchResults;
};

export const loadMoreSearchResults = async ({
  setIsLoadingMoreResults,
  setChunksLoaded,
  searchResults,
  setSearchResults,
  chunksLoaded,
  locale,
  searchExpression,
  activeFilters,
  setNoMoreResults,
}) => {
  setIsLoadingMoreResults(true);

  new request(`vertex`)
    .get({
      locale,
      searchExpression,
      offset: chunksLoaded * 10,
      filters: activeFilters.tags.join(','),
    })
    .then(data => {
      if (data?.state === 'No search results') {
        // log.warning('No search results');  // Ithan: This is a bit noisy, and does not show any useful information.
        // Also, again, probably not an error, just no results.
        log.info(
          `[search_searchExpression_loadMore] No search results for expression: ${searchExpression}. Locale: ${locale};`
        );
        setNoMoreResults(true);
        return;
      }

      if (!data?.length) {
        // Same here
        log.info(
          `[search_searchExpression_loadMore] No search results for expression: ${searchExpression}. Locale: ${locale};`
        );
        setNoMoreResults(true);
        return;
      }

      const deduplicatedSearchResults = processNewSearchResults({
        currentSearchResults: searchResults,
        fetchedData: data,
      });

      setSearchResults(deduplicatedSearchResults);
      setChunksLoaded(chunksLoaded + 1);
    })
    .catch(error => {
      log.error(error);
    })
    .finally(() => {
      setIsLoadingMoreResults(false);
    });
};
